export class Pricing {

  constructor() {
    this._pricing = document.querySelector('.s-pricing-custom');

    if (this._pricing) {
      this.init();
    }
  }

  init() {
    this._tabs = this._pricing.querySelectorAll('.s-pricing-custom_tabs-item')
    this.tabsFloatingCursor()
    this.initPricing()
    this.setPopularPlan()

    this._tabs.forEach(tab => {
      tab.addEventListener('click', (e) => {

        this._tabs.forEach(tab => {
          tab.classList.remove('active')
        })

        e.currentTarget.classList.add('active')
        this.changeCursorPosition()
        this.initPricing()
        this.setPopularPlan()
      })
    })
  }

  tabsFloatingCursor() {
    let parent = this._pricing.querySelector('.s-pricing-custom_tabs');
    this._floatingCursor = document.createElement('div')
    this._floatingCursor.classList.add('s-pricing-custom_tabs-cursor')

    // Trouver l'onglet actif
    let activeTab = this._pricing.querySelector('.s-pricing-custom_tabs-item.active');
    if (activeTab) {
      let tabRect = activeTab.getBoundingClientRect();
      let parentRect = parent.getBoundingClientRect();

      // Calculer la position relative à l'onglet actif
      let leftPosition = tabRect.left - parentRect.left;

      this._floatingCursor.style.left = `${leftPosition}px`;
      this._floatingCursor.style.width = `${tabRect.width}px`;
    }

    parent.append(this._floatingCursor);
  }

  changeCursorPosition() {
    let cursor = this._pricing.querySelector('.s-pricing-custom_tabs-cursor');
    let parent = this._pricing.querySelector('.s-pricing-custom_tabs');

    // Trouver l'onglet actif après le changement
    let activeTab = this._pricing.querySelector('.s-pricing-custom_tabs-item.active');
    if (activeTab) {
      let tabRect = activeTab.getBoundingClientRect();
      let parentRect = parent.getBoundingClientRect();

      // Calculer la position relative à l'onglet actif
      let leftPosition = tabRect.left - parentRect.left;

      cursor.style.left = `${leftPosition}px`;
      cursor.style.width = `${tabRect.width}px`;
    }
  }

  initPricing() {
    let activeTab = this._pricing.querySelector('.s-pricing-custom_tabs-item.active');
    let type = activeTab.getAttribute('type');

    let plans = this._pricing.querySelectorAll('.c-plan');

    plans.forEach(plan => {
      let elementPrice = plan.querySelector('.c-plan-pricing');

      if (!elementPrice) return;

      let outputPrice = plan.querySelector('.c-plan-pricing_dynamic-price');
      let outputText = plan.querySelector('.c-plan-pricing_dynamic-text');

      outputPrice.innerHTML = '';
      outputText.innerHTML = '';

      let price = elementPrice.getAttribute(`${type}-price`);
      let objPer = TEXT_PER.find(t => t.type === type);

      outputPrice.innerHTML = '<span>' + price + ' €</span> /' + objPer.text + ' HT';
      outputText.innerHTML = '<span>Total ' + price + ' €/' + objPer.text + ' HT</span> <span>facturé chaque ' + objPer.textSingular + '</span>';
    })
  }

  setPopularPlan() {
    let activeTab = this._pricing.querySelector('.s-pricing-custom_tabs-item.active');
    let type = activeTab.getAttribute('type');
    let position = this._pricing.getAttribute(`pos-${type}`);

    if (!position) return;

    let plansNormal = this._pricing.querySelectorAll('.s-pricing-custom_plans .c-plan');
    let plansSlider = this._pricing.querySelectorAll('.s-pricing-custom_plans--slider .c-plan');

    let plans = [...plansNormal, ...plansSlider];

    plans.forEach((plan, index) => {
      plan.classList.remove('popular-plan');
    })

    plansNormal.forEach((plan, index) => {
      if ((index + 1) === parseInt(position)) {
        plan.classList.add('popular-plan');
      }
    })

    plansSlider.forEach((plan, index) => {
      if ((index + 1) === parseInt(position)) {
        plan.classList.add('popular-plan');
      }
    })
  }
}

export const TEXT_PER = [
  {type: 'mensual', text: 'mois', textSingular: 'mois'},
  {type: 'annual', text: 'an', textSingular: 'année'}
]
